import React from 'react';
import './PageFrame.css';

function PageFrame({ children }) {
  return (
    <div className="frame">
      <div className="scroll">
        <div className="corner-decor tl"></div>
        <div className="corner-decor tr"></div>
        <div className="corner-decor bl"></div>
        <div className="corner-decor br"></div>
        {children}
        <p className="footer-text">© 2025 Voxale · Not affiliated with Mojang Studios</p>
      </div>
    </div>
  );
}

export default PageFrame;
